import * as tslib_1 from "tslib";
import { auth as authFB } from "@/helpers/firebase";
import friendly from "@/helpers/friendly";
import { Vue, Component } from "vue-property-decorator";
import loader from "@/components/loader.vue";
let widget = class widget extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.mode = "login";
        this.login = {
            lastErr: "",
            email: "",
            password: ""
        };
        this.create = {
            lastErr: "",
            email: "",
            password: "",
            confirmPassword: ""
        };
    }
    async siEmail() {
        this.loading = true;
        this.login.lastErr = "";
        try {
            let res = await authFB.signInWithEmailAndPassword(this.login.email, this.login.password);
            window.location.href = window.location + '';
        }
        catch (err) {
            if (err.code && err.code == "auth/too-many-requests") {
                this.showRecapcha();
            }
            else {
                this.login.lastErr = friendly.err(err);
            }
        }
        this.loading = false;
    }
    createAccount() {
        if (this.create.password != this.create.confirmPassword) {
            this.create.lastErr = String(this.$t("login.err.passwordNotMatchConfirmPassword"));
            return;
        }
    }
    showRecapcha() {
        console.log("show recapcha!!!");
    }
};
widget = tslib_1.__decorate([
    Component({ components: { loader } })
], widget);
export default widget;
